module.exports = __webpack_public_path__ + "img/calendar.da3c13db.svg";